/**
 * news
 */
'use strict';
import AppNewsEntry from '@/_modules/app_news_entry';

document.addEventListener('DOMContentLoaded', () => {
  new AppNewsEntry();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
